declare var process: any;

const Settings = {
    AppName: "ASRS Web Client",
    AppID: process.env.REACT_APP_ID as number,
    ApiUrl: process.env.REACT_APP_API_URL as string,
    ServicesUrl: process.env.REACT_APP_SERVICES_URL as string,
    AsrsLegacyUrl: process.env.REACT_APP_LEGACY_URL as string,

    AsanaAccessToken: process.env.REACT_APP_ASANA_ACCESS_TOKEN as string,

    ClientId: process.env.REACT_APP_CLIENT_ID as string,
    ClientSecret: process.env.REACT_APP_CLIENT_SECRET as string,

    ClientName: process.env.REACT_APP_CLIENT_NAME as string,
    ClientNameAbbreviation: process.env.REACT_APP_CLIENT_NAME_SHORT as string,

    DoSessionSave: process.env.REACT_APP_DO_SESSION_SAVE === "true",

    /** For any items stored in local storage, use this prefix for the key name */
    LocalStorageKeyPrefix: "asrs.client.",

    /** Whether or not to output Log entries to console */
    OutputLog: process.env.REACT_APP_LOG_TO_CONSOLE === "true",

    ResponsiveAdminBreakpointWidth: 900,
    ResponsiveBreakpointWidth: 970,

    TokenCookie: "asrs.token",
    LegacyAuthCookie: "ASRS_LEGACY_AUTH",
    CookieDomain: process.env.REACT_APP_COOKIE_DOMAIN as string,

    CurrentAnnualMeetingID: parseInt(process.env.REACT_APP_CURRENT_AM_ID as string, 10),
};

export default Settings;



// WEBPACK FOOTER //
// ./src/settings.ts